import forOwn from 'lodash/forOwn';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import React from 'react';
import { connect } from 'react-redux';
import { wrapper } from '~/store';
import nextI18nextConfig from '~/../next-i18next.config';
import Config, { keyConfig } from '~/config';
import Layout from '~/containers/Layout';
import SimilarContainer from '~/containers/SimilarPage';
import { loadSimilarData } from '~/containers/SimilarPage/actions';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import HrefLangs, { getCanonical } from '~/components/HrefLangs';
import { urls } from '~/utils';

@connect((state) => ({
  photo: state.similarPage.data,
}))
@defaultPage()
class SimilarPage extends React.Component {
  // static async getInitialProps({ query, store, clientIp, api }) {
  //   const language = store.getState().language.currentLanguage;
  //   store.dispatch(
  //     loadSimilarData(
  //       {
  //         order_by: query.order_by || 'popular',
  //         lang: language,
  //         data_id: query.data_id,
  //         page: query.page,
  //         per_page: query.per_page,
  //         service_type_for_similar:
  //           query.service_type_for_similar || Config.serviceType,
  //         same_creator: query.same_creator,
  //         clientIp,
  //       },
  //       api,
  //     ),
  //   );
  //   return { query };
  // }

  renderAsPath = (query, id) => {
    query = Object.assign({}, query);
    const url = `/search-result/similar/${id}`;
    let params = '';
    let isFirstIndex = true;
    forOwn(query, (query, key) => {
      if (Array.isArray(query)) {
        query = query.map(({ query }) => query).toString();
      }

      if (
        query &&
        key !== 'is_tag' &&
        key !== 'lng' &&
        key !== 'token' &&
        key !== 'slug'
      ) {
        if (isFirstIndex) {
          params = params.concat(`?${key}=${query}`);
          isFirstIndex = false;
        } else {
          params = params.concat(`&${key}=${query}`);
        }
      }
    });

    console.log('paramsparamsparams', params);

    return url + params;
  };

  render() {
    const { t, lng, photo, query } = this.props;
    const ID = photo ? photo.id : '';
    const keywords = photo ? Config.getTitleByLanguage(photo.title, lng) : '';
    // const canonical = urls.getCanonicalURL(lng, `/search-result/similar/${ID}`);
    const canonical = getCanonical(`/search-result/similar/${ID}`, lng);

    return (
      <Layout>
        <Head>
          <title>
            {t(keyConfig.get('title_similar_page'), { ID, title: keywords })}
          </title>
          <meta
            id="meta-keywords"
            name="keywords"
            content={t(keyConfig.get('meta_keywords_similar_page'), {
              title: keywords,
              ID,
            })}
          />
          <meta
            id="meta-description"
            name="description"
            content={t(keyConfig.get('meta_description_similar_page'), {
              title: keywords,
            })}
          />
          <HrefLangs pagePath={this.renderAsPath(query, ID)} lng={lng} />
          <meta
            property="og:image"
            content={`${
              Config.staticPrefix
            }/static/assets/image/logo/${Config.renderImageShareTwitter()}`}
          />
          <meta
            property="og:title"
            content={t(keyConfig.get('title_similar_page'), {
              title: keywords,
              ID,
            })}
          />
          <meta
            property="og:description"
            content={t(keyConfig.get('meta_description_similar_page'), {
              title: keywords,
            })}
          />

          <meta property="og:type" content="article" />
          <meta
            property="og:description"
            content={t(keyConfig.get('meta_description_similar_page'), {
              title: keywords,
            })}
          />
          <meta property="og:url" content={canonical} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={canonical} />
          <meta
            name="twitter:title"
            content={t(keyConfig.get('title_similar_page'), {
              title: keywords,
              ID,
            })}
          />
          <meta
            name="twitter:description"
            content={t(keyConfig.get('meta_description_similar_page'), {
              title: keywords,
            })}
          />
          <meta
            name="twitter:image"
            content={`${
              Config.staticPrefix
            }/static/assets/image/logo/${Config.renderImageShareTwitter()}`}
          />
          <meta name="twitter:site" content={`${Config.getSiteURL()}`} />
          <meta name="twitter:creator" content={`@${Config.getName()}`} />
        </Head>
        <SimilarContainer />
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    // const language = store.getState().language.currentLanguage;
    // const language = currentLanguage;

    store.dispatch(
      loadSimilarData(
        {
          // order_by: query.order_by || 'popular',
          // lang: language,
          data_id: query.data_id,
          page: query.page,
          per_page: query.per_page,
          // service_type_for_similar:
          //   query.service_type_for_similar || Config.serviceType,
          // same_creator: query.same_creator,
          // clientIp,
          keyword: query.keyword,
          serviceTypeData: Config.serviceType,
        },
        api,
      ),
    );
    console.log('queryqueryquery', query);

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    if (store.getState().similarPage?.collection.length === 0) {
      ctx.res.statusCode = 404;
    }

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default SimilarPage;
